import firebase from "../../config/firebase";
import { toast } from "react-toastify";

export const getParentMenus = (id) => async (dispatch) => {
  dispatch(menuLoading(true));
  try {
    const menusQuery = firebase
      .firestore()
      .collection("menus")
      .orderBy("position", "asc")
      .where("restaurantID", "==", id)
      .where("isVisible", "==", true);

    menusQuery.onSnapshot(async (querySnapshot) => {
      const parentMenus = [];

      for (const doc of querySnapshot.docs) {
        const parentMenuData = doc.data();
        const menuId = doc.id;

        const itemsSnapshot = await firebase
          .firestore()
          .collection("items")
          .where("menuID", "==", menuId)
          .get();

        const categorySet = new Set();

        for (const itemDoc of itemsSnapshot.docs) {
          const item = itemDoc.data();
          if (item.isVisible !== false) {
            categorySet.add(item.categoryName);
            break;
          }
        }

        const uniqueCategories = Array.from(categorySet);

        if (uniqueCategories?.length > 0) {
          parentMenus.push({
            id: menuId,
            ...parentMenuData,
            categories: uniqueCategories,
          });
        }
      }

      dispatch({
        type: "PARENT_MENUS",
        payload: parentMenus,
      });
      dispatch(menuLoading(false));
    });
  } catch (error) {
    console.error("Error fetching parent menus:", error);
    dispatch(menuLoading(false));
  }
};

export const getMenuCategories = (id) => async (dispatch) => {
  try {
    dispatch(categoriesLoader(true));

    firebase
      .firestore()
      .collection("categories")
      .where("menuID", "==", id)
      .where("isVisible", "==", true)
      .orderBy("createdAt", "desc")
      .onSnapshot(async (query) => {
        let menuCategories = [];
        for (let doc of query.docs) {
          if (doc) {
            menuCategories.push({ id: doc.id, ...doc.data() });
          }
        }
        dispatch({
          type: "MENU_CATEGORIES",
          payload: menuCategories,
        });
        dispatch(categoriesLoader(false));
      });
  } catch (err) {
    toast.error(err.message);
    dispatch(categoriesLoader(false));
  }
};

export const getRecommendedData =
  (id, onSuccess = () => {}) =>
  (dispatch) => {
    try {
      firebase
        .firestore()
        .collection("items")
        .doc(id)
        .onSnapshot((doc) => {
          if (doc.exists) {
            dispatch({
              type: "GET_RECOMMENDED_DATA",
              payload: { id: doc.id, ...doc.data() },
            });
            onSuccess(doc.data()); // Call success callback with fresh data
          } else {
            dispatch({
              type: "GET_RECOMMENDED_DATA",
              payload: "Item not found",
            });
          }
        });
    } catch (error) {
      dispatch({
        type: "GET_RECOMMENDED_DATA",
        payload: error.message,
      });
    }
  };

export const getMenuItems = (id, categoryID) => async (dispatch) => {
  try {
    dispatch(menuLoader(true));
    firebase
      .firestore()
      .collection("items")
      .where("restaurantID", "==", id)
      .where("categoryId", "==", categoryID)
      .where("isVisible", "==", true)
      .orderBy("createdAt", "desc")
      .onSnapshot(async (query) => {
        let menuItem = [];
        if (!query.empty) {
          for (let doc of query.docs) {
            const label = doc.data().labels;
            let labelsData = [];
            label?.forEach((item) =>
              firebase
                .firestore()
                .collection("labels")
                .doc(item.id)
                .get()
                .then((labelDoc) => {
                  let labData = labelDoc.data();
                  labelsData.push({
                    ...item,
                    labelURL: labData?.labelURL,
                  });
                })
            );
            menuItem.push({
              id: doc.id,
              ...doc.data(),
              labels: labelsData,
            });
          }
        }
        dispatch({ type: "MENU_ITEMS", payload: menuItem });
        dispatch(menuLoader(false));
      });
  } catch (err) {
    toast.error(err.message);
    dispatch(menuLoader(false));
  }
};

export const getOffers = async (id, dispatch) => {
  try {
    dispatch(offerLoader(true));

    const offersQuery = firebase
      .firestore()
      .collection("offers")
      .where("restaurantID", "==", id)
      .orderBy("createdAt", "desc");

    const unsubscribe = offersQuery.onSnapshot((snapshot) => {
      try {
        const offers = [];
        snapshot.forEach((doc) => {
          offers.push({ id: doc.id, ...doc.data() });
        });
        dispatch({ type: "FETCH_OFFERS", payload: offers });
      } catch (innerErr) {
        console.error("Error processing snapshot:", innerErr);
      }
    });

    return unsubscribe;
  } catch (err) {
    console.error("Error setting up offer listener:", err);
    return () => {};
  } finally {
    dispatch(offerLoader(false));
  }
};

export const menuLoader = (val) => async (dispatch) => {
  dispatch({
    type: "MENU_LOADER",
    payload: val,
  });
};
export const menuLoading = (val) => async (dispatch) => {
  dispatch({
    type: "MENU_DETAIL_LOADER",
    payload: val,
  });
};
export const offerLoader = (val) => async (dispatch) => {
  dispatch({
    type: "OFFER_LOADER",
    payload: val,
  });
};
export const categoriesLoader = (val) => async (dispatch) => {
  dispatch({
    type: "CATEGORIES_LOADER",
    payload: val,
  });
};
